export default "/ticket-waiver.50a8b3e2-e98823.png";